import { HttpInterceptorFn } from "@angular/common/http";
import { finalize } from "rxjs";
import { LoadingSpinnerService } from "./loading-spinner.service";
import { inject } from "@angular/core";
import { AuthService } from "./transaction/auth.service";

export const authInterceptor: HttpInterceptorFn = (req, next) => {

    const excludedUrls = ['/v1/auth/session/refresh', '/v1/auth/session/initiate'];
    const loadingService = inject(LoadingSpinnerService);
    const authService = inject(AuthService);

    loadingService.show();

    const isExcluded = excludedUrls.some((url) => req.url.includes(url));

    if (isExcluded) {
        return next(req).pipe(
            finalize(() => {
                loadingService.hide();
            })
        );
    }

    if (authService.diasporaSessionToken() === null) {
        authService.diasporaSessionToken.set(localStorage.getItem('token'));
    }

    const token = localStorage.getItem('token') || authService.diasporaSessionToken();
    let headers: any = req.headers;

    if (token && !isExcluded) {
        headers = headers.set('Authorization', `Bearer ${token}`);
        const authReq = req.clone({
            headers: headers
        });
        return next(authReq).pipe(
            finalize(() => {
                loadingService.hide();
            })
        );
    }

    return next(req).pipe(
        finalize(() => {
            loadingService.hide();
        })
    );
};
